<div class="manual-refunds-list">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h5 class="mb-0">
      <i class="fa fa-hand-holding-dollar text-warning me-2"></i>
      {{ 'manageEvent.manualRefunds.title' | translate }}
    </h5>
    <button class="btn btn-sm btn-outline-primary" (click)="loadRefunds()" [disabled]="loading">
      <i class="fa fa-refresh" [class.fa-spin]="loading"></i>
    </button>
  </div>

  @if (refunds.length > 0) {
    <div class="alert alert-warning mb-4">
      <i class="fa fa-info-circle me-2"></i>
      {{ 'manageEvent.manualRefunds.description' | translate }}
    </div>

    <!-- Filter tabs -->
    <ul class="nav nav-pills mb-3">
      <li class="nav-item">
        <a class="nav-link" [class.active]="filter === 'all'" (click)="filter = 'all'" href="javascript:void(0)">
          {{ 'common.all' | translate }} ({{ refunds.length }})
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [class.active]="filter === 'pending'" (click)="filter = 'pending'" href="javascript:void(0)">
          {{ 'manageEvent.manualRefunds.pending' | translate }}
          @if (pendingCount > 0) {
            <span class="badge bg-warning ms-1">{{ pendingCount }}</span>
          }
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [class.active]="filter === 'completed'" (click)="filter = 'completed'" href="javascript:void(0)">
          {{ 'manageEvent.manualRefunds.completed' | translate }} ({{ completedCount }})
        </a>
      </li>
    </ul>

    <!-- Refunds table -->
    @if (loading) {
      <div class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    } @else {
      <div class="table-responsive">
        <table class="table table-hover align-middle">
          <thead class="table-light">
            <tr>
              <th>{{ 'manageEvent.manualRefunds.orderNumber' | translate }}</th>
              <th>{{ 'manageEvent.manualRefunds.customer' | translate }}</th>
              <th class="text-end">{{ 'manageEvent.manualRefunds.amount' | translate }}</th>
              <th>{{ 'manageEvent.manualRefunds.reason' | translate }}</th>
              <th>{{ 'manageEvent.manualRefunds.status' | translate }}</th>
              <th class="text-center">{{ 'common.actions' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (refund of filteredRefunds; track refund.requirement_id) {
              <tr>
                <td>
                  <strong>#{{ refund.order_id }}</strong>
                </td>
                <td>
                  @if (refund.user) {
                    <div>{{ refund.user.first_name }} {{ refund.user.last_name }}</div>
                    <small class="text-muted">{{ refund.user.email }}</small>
                  } @else {
                    <span class="text-muted">-</span>
                  }
                </td>
                <td class="text-end">
                  <strong>{{ formatAmount(refund.amount_cents) }} NOK</strong>
                </td>
                <td>
                  <span class="badge"
                        [class.bg-secondary]="refund.reason === 'no_stripe_payment'"
                        [class.bg-danger]="refund.reason === 'refund_failed'">
                    {{ getReasonLabel(refund.reason) }}
                  </span>
                  @if (refund.error_message) {
                    <br>
                    <small class="text-danger">{{ refund.error_message }}</small>
                  }
                </td>
                <td>
                  @if (refund.status === 'pending') {
                    <span class="badge bg-warning">{{ 'manageEvent.manualRefunds.pending' | translate }}</span>
                  } @else if (refund.status === 'completed') {
                    <span class="badge bg-success">{{ 'manageEvent.manualRefunds.completed' | translate }}</span>
                    @if (refund.completed_at) {
                      <br>
                      <small class="text-muted">{{ refund.completed_at | date:'short' }}</small>
                    }
                  } @else {
                    <span class="badge bg-secondary">{{ refund.status }}</span>
                  }
                </td>
                <td class="text-center">
                  @if (refund.status === 'pending') {
                    <button class="btn btn-sm btn-success"
                            (click)="markComplete(refund)"
                            [disabled]="processingId === refund.requirement_id">
                      @if (processingId === refund.requirement_id) {
                        <span class="spinner-border spinner-border-sm" role="status"></span>
                      } @else {
                        <i class="fa fa-check me-1"></i>
                        {{ 'manageEvent.manualRefunds.markComplete' | translate }}
                      }
                    </button>
                  } @else {
                    <i class="fa fa-check-circle text-success"></i>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      @if (filteredRefunds.length === 0) {
        <div class="text-center py-4 text-muted">
          {{ 'manageEvent.manualRefunds.noRefunds' | translate }}
        </div>
      }
    }
  } @else if (!loading) {
    <div class="text-center py-5 text-muted">
      <i class="fa fa-check-circle fa-3x mb-3 text-success"></i>
      <p>{{ 'manageEvent.manualRefunds.noManualRefundsRequired' | translate }}</p>
    </div>
  }
</div>
